import { FC } from 'react';

import { twMerge } from 'tailwind-merge';

import { Label } from '../../label';
import { RadioGroupItem as RadioGroupItemComponent } from '../../radio-group';
import { TRadioGroupItem } from './types';

export const RadioGroupItem: FC<TRadioGroupItem> = ({
  value,
  checked,
  id,
  children,
  variant = 'default',
}) => {
  return (
    <Label htmlFor={id}>
      <div
        className={twMerge(
          'flex w-full gap-4 rounded-[20px] p-4',
          variant === 'default' && checked ? 'bg-brand-500' : 'bg-base-500',
          variant === 'dashboard' && 'items-center',
        )}
      >
        <RadioGroupItemComponent
          id={id}
          value={value}
          checked={checked}
          variant={variant === 'default' ? 'secondary' : variant}
        />
        <div>{children}</div>
      </div>
    </Label>
  );
};
